import { InsuranceEntity } from 'backend-entity';

export type CrmVehicleInsuranceCreateRequestDto = Omit<InsuranceEntity, 'id' | 'createdAt' | 'updatedAt' | 'vehicleId'>;
